import React, { useEffect, useState } from "react";
import Select from "react-select";
import axiosInstance from "../apiconfig";
import "../styles/reports.css";
import { FarmerCard } from "./FarmerCard";

export default function FarmerLedger() {
  const [farmers, setFarmers] = useState([]);
  const [selectedFarmers, setSelectedFarmers] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [data, setData] = useState([]);
  const [printMode, setPrintMode] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadFarmers();
  }, []);

  const loadFarmers = async () => {
    const res = await axiosInstance.get("/api/farmers/GetFarmers");
    setFarmers(
      res.data.map(f => ({
        value: f.id,
        label: `(${f.code})${f.firstName} ${f.lastName}`
      }))
    );
  };

  const search = async () => {
    try {
      setLoading(true);

      const farmerIds = selectedFarmers.map(x => x.value);
      const res = await axiosInstance.post("/api/report/GetReports", {
        farmerIds,
        date
      });

      const sortedData = [...(res?.data ?? [])].sort(
        (a, b) => Number(a.code) - Number(b.code)
      );

      setData(sortedData);


    } catch (err) {
      console.error(err);
      alert("Failed to load report");
    } finally {
      setLoading(false);
    }
  };


  const handlePrint = () => {
    if (data.length === 0) {
      alert("Search for a report before printing");
      return;
    }

    window.print();
  };

  const totalGrandAmount = data.reduce(
    (sum, f) => sum + (f.oldAmounts?.grandTotalAmount || 0),
    0
  );

  const totalInterestAmount = data.reduce(
    (sum, f) => sum + (f.oldAmounts?.interestAmount || 0),
    0
  );

  const updateAmount = async () => {
    const formattedDate = new Intl.DateTimeFormat("en-GB").format(new Date(date));

    const ok = window.confirm(
      `Are you sure you want to update amount for date ${formattedDate}?`
    );

    if (!ok) return;

    setLoading(true);

    try {
      const farmerIds = selectedFarmers.map(x => x.value);

      const res = await axiosInstance.post(
        "/api/report/UpdateOldAmount",
        {
          farmerIds,
          date,
        }
      );

      if (!res) return;

      alert("Amounts updated successfully");
    } finally {
      setLoading(false);
    }

    // Reload report if needed
    // search();
  };




  return (
    <div className={`ledger-page ${printMode ? 'print-mode' : ''}`}>
      {loading && (
        <div className="loader-overlay print-hide">
          <div className="spinner"></div>
          <span>Loading report...</span>
        </div>
      )}

      <div className="print-hide">
        {/* ================= FILTER BAR ================= */}
        <div className="filter-bar">
          <Select
            isMulti
            options={farmers}
            value={selectedFarmers}
            onChange={setSelectedFarmers}
            placeholder="All Farmers"
            className="farmer-select"
          />

          <input
            type="date"
            value={date}
            onChange={e => setDate(e.target.value)}
          />

          <button onClick={search} className="search-btn" disabled={loading}>
            {loading ? "Loading..." : "🔍 Search"}
          </button>

          <button onClick={handlePrint} className="print-btn" disabled={loading}>
            🖨 Print / Save PDF
          </button>

          <button className="primary-btn" onClick={updateAmount} disabled={loading}>
            Update Amount
          </button>


        </div>

        {/* ================= TOTAL SUMMARY (TOP ROW) ================= */}
        {data.length > 0 && (
          <div className="summary-bar">
            <div className="summary-item">
              <span>Total Grand Amount: </span>
              <strong>
                ₹ {totalGrandAmount.toLocaleString('en-IN')}
              </strong>

            </div>

            <div className="summary-item">
              <span>Total Interest Amount: </span>
              <strong>
                ₹ {totalInterestAmount.toLocaleString('en-IN')}
              </strong>

            </div>

            <div className="summary-item">
              <span>Total Farmers: </span>
              <strong>{data.length}</strong>
            </div>

          </div>
        )}
      </div>

      {/* ================= BODY ================= */}
      <div className="ledger-body">
        {data.map((farmer, index) => (
          <FarmerCard key={farmer.id} farmer={farmer} index={index} />
        ))}
      </div>



    </div>
  );
}